import mapCreatorConnect from './map-creator-connect';

export {
  mapCreatorConnect
};



// WEBPACK FOOTER //
// ./src/browser/higher-order-components/index.js